// extracted by mini-css-extract-plugin
export default {"brand":"row_brand__RSQOE","nvidia":"row_nvidia__rbXLs","amd":"row_amd__ZBHwW","power":"row_power__tM2XW","selected":"row_selected__9sEMl"};